// extracted by mini-css-extract-plugin
module.exports = {"category-name-label":"category-name-label___v6DhG"};